import { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md';
  children: ReactNode;
}

export function Button({ variant = 'secondary', size = 'md', className, children, ...rest }: Props) {
  return (
    <button
      className={clsx(
        'inline-flex items-center justify-center rounded-md font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
        size === 'sm' ? 'px-2.5 py-1.5 text-xs' : 'px-3.5 py-2 text-sm',
        variant === 'primary'   && 'bg-accent text-white hover:bg-accent-dark',
        variant === 'secondary' && 'bg-surface border border-border text-text-secondary hover:bg-page',
        variant === 'ghost'     && 'text-text-secondary hover:bg-page',
        variant === 'danger'    && 'bg-surface border border-border text-danger hover:bg-red-50',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
